import { useRecoilState } from 'recoil';
import { personAtom } from '../atoms/person';

export const usePerson = () => {
    const [person, setPerson] = useRecoilState(personAtom);

    return { person, setPerson };
};